import { render, staticRenderFns } from "./SchoolJobSeekersTBD.vue?vue&type=template&id=abdc62da&scoped=true&"
import script from "./SchoolJobSeekersTBD.vue?vue&type=script&lang=js&"
export * from "./SchoolJobSeekersTBD.vue?vue&type=script&lang=js&"
import style0 from "./SchoolJobSeekersTBD.vue?vue&type=style&index=0&id=abdc62da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdc62da",
  null
  
)

export default component.exports